import { render } from "./ReleasePurchaseStatusChip.vue?vue&type=template&id=20d9d70a&scoped=true"
import script from "./ReleasePurchaseStatusChip.vue?vue&type=script&lang=js"
export * from "./ReleasePurchaseStatusChip.vue?vue&type=script&lang=js"

import "./ReleasePurchaseStatusChip.vue?vue&type=style&index=0&id=20d9d70a&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-20d9d70a"]])

export default __exports__